import { MAX_COMPONENTS_EXCEEDED_ERROR_CODE } from 'modules/quotes/quoteItemComponents/bomBuilder/const';

import { getErrorMessage } from 'utils/stringUtils';

const getErrorCode = (error: unknown): string | undefined => {
  // NOTE: matched structurally rather than with `instanceof FetchError`, because two
  // separate FetchError implementations reach these handlers: the one in
  // @frontend/api and the legacy constructor in utils/request.js used by the sagas.
  // Both set `code` from the response payload.
  if (typeof error === 'object' && error !== null && 'code' in error) {
    const { code } = error as { code: unknown };
    return typeof code === 'string' ? code : undefined;
  }
  return undefined;
};

/**
 * Pull the message off a failed request, but only when it failed on the component
 * limit.
 *
 * The endpoints that add components reject plenty of other things (nested parts,
 * draft BOMs in progress, permissions, unexpected server errors), and those messages
 * are not all written for an end user to read. So we only surface this one, matched on
 * the API's error code so the copy stays free to change, and let every other failure
 * fall back to the caller's own generic message.
 *
 * @returns the API's message for the component limit, or undefined for anything else
 */
export const getComponentLimitErrorMessage = (
  error: unknown,
): string | undefined =>
  getErrorCode(error) === MAX_COMPONENTS_EXCEEDED_ERROR_CODE
    ? getErrorMessage(error)
    : undefined;
